import SortDescending from '@/assets/images/icons/SortDescending.svg'
import { OrderBy } from '@/utils'
import { useState } from 'react'
import EmailIcon from '@/assets/images/icons/EmailIcon'
import ReferralStatusPill from './referral-status'
import { useTranslation } from 'react-i18next'
import { ReferralspbReferral } from '@itsrever/rever-api'
import clsx from 'clsx'

export default function ReferralsTable({
  referrals
}: {
  referrals: ReferralspbReferral[]
}) {
  const [orderBy, setOrderBy] = useState<string>(OrderBy.Desc)

  const handleOrderChange = () => {
    setOrderBy(orderBy === OrderBy.Asc ? OrderBy.Desc : OrderBy.Asc)
  }

  return (
    <div className="w-full rounded-xl bg-white p-4">
      <div className="grid w-full grid-cols-[repeat(7,_minmax(0,_1fr))] items-center gap-y-[2px]">
        <ReferralColumnTitles
          dateOrderBy={orderBy}
          onOrderChange={handleOrderChange}
        />
        {referrals.length > 0 &&
          referrals
            .sort((a, b) => {
              const dateA = new Date(a.referred_time!)
              const dateB = new Date(b.referred_time!)

              if (orderBy === OrderBy.Asc) {
                return dateA > dateB ? 1 : -1
              } else {
                return dateA < dateB ? 1 : -1
              }
            })
            .map((referral) => {
              const referredDate =
                new Date(referral.referred_time!).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit'
                }) +
                ' · ' +
                new Date(referral.referred_time!).toLocaleDateString()
              return (
                <>
                  <div
                    className="flex h-full cursor-pointer flex-col justify-center bg-white px-4 py-[0.6rem]"
                    key={referral.referral_id + referredDate}
                  >
                    <p>{referredDate}</p>
                  </div>
                  <div className="flex h-full cursor-pointer flex-col justify-center bg-white px-4 py-[0.6rem]">
                    <p>{referral.referred_email}</p>
                  </div>
                  <div className="flex h-full cursor-pointer flex-col justify-center bg-white px-4 py-[0.6rem]">
                    <p>
                      {referral.referred_brand
                        ? referral.referred_brand
                        : referral.referred_email!.split('@')[1].split('.')[0]}
                    </p>
                  </div>
                  <div className="flex h-full cursor-pointer flex-col justify-center bg-white px-4 py-[0.6rem]">
                    <p>{referral.referred_phone}</p>
                  </div>
                  <div className="flex h-full cursor-pointer flex-col justify-center bg-white px-4 py-[0.6rem]">
                    <p>{referral.website}</p>
                  </div>
                  <div className="flex h-full cursor-pointer flex-col justify-center bg-white px-4 py-[0.6rem]">
                    <ReferralStatusPill status={referral.status!} />
                  </div>
                  <div className="flex h-full cursor-pointer flex-col justify-center bg-white px-4 py-[0.6rem]">
                    <div className="flex items-center justify-end gap-3">
                      <a
                        className="h-6 w-7 text-center"
                        href={`mailto:${referral.referred_email}`}
                      >
                        <EmailIcon color={'#345CFF'} />
                      </a>
                    </div>
                  </div>
                </>
              )
            })}
      </div>
    </div>
  )
}

const ReferralColumnTitles = ({
  dateOrderBy,
  onOrderChange
}: {
  dateOrderBy: string
  onOrderChange: () => void
}) => {
  const { t } = useTranslation()

  const titles = t('referrals.table.columns', {
    returnObjects: true
  })

  return (
    <>
      {Object.entries(titles).map(([key, title], i) => {
        return (
          <div
            className={clsx(
              'flex h-full cursor-pointer items-center bg-[#f6f8fa] px-4 py-[0.6rem]',
              {
                'rounded-l-[0.75rem]': i === 0,
                'rounded-r-[0.75rem] justify-end': i === 6
              }
            )}
            key={key}
          >
            <p>
              <b>{title}</b>
            </p>
            {i === 0 && (
              <img
                className="size-6 transition-all"
                style={{
                  transform:
                    dateOrderBy === OrderBy.Asc
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                }}
                src={SortDescending}
                onClick={() => onOrderChange()}
              />
            )}
          </div>
        )
      })}
    </>
  )
}
